import Api from '../Api';

import { url } from './config';

const api = new Api(url);

export default api;
